
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import SellerCard from './SellerCard';
import { Link } from 'react-router-dom';

// Mock data for featured sellers
const mockFeaturedSellers = [
  {
    id: '1',
    name: 'Tech Link Agency',
    bio: 'Specializing in tech and SaaS backlinks with high domain authority sites. 5+ years of link building experience.',
    logoUrl: '/placeholder.svg',
    verified: true,
    offerCount: 15,
    rating: 4.9,
    reviewCount: 124,
    tags: ['Tech', 'SaaS', 'Marketing'],
    slug: 'tech-link-agency'
  },
  {
    id: '2',
    name: 'Finance Link Pro',
    bio: 'Premium financial sector links with established blogs and news sites. Quick turnaround and white-glove service.',
    logoUrl: '/placeholder.svg',
    verified: true,
    offerCount: 8,
    rating: 4.7,
    reviewCount: 89,
    tags: ['Finance', 'Banking', 'Insurance'],
    slug: 'finance-link-pro'
  },
  {
    id: '3',
    name: 'Health Niche Links',
    bio: 'High-quality health and wellness links from authoritative sites. YMYL-compliant and Google-friendly.',
    logoUrl: '/placeholder.svg',
    verified: false,
    offerCount: 12,
    rating: 4.8,
    reviewCount: 67,
    tags: ['Health', 'Wellness', 'Nutrition'],
    slug: 'health-niche-links'
  },
  {
    id: '4',
    name: 'Travel Backlinks',
    bio: 'Travel industry links from established blogs with real traffic. International coverage across multiple languages.',
    logoUrl: '/placeholder.svg',
    verified: true,
    offerCount: 20,
    rating: 4.6,
    reviewCount: 105,
    tags: ['Travel', 'Tourism', 'Hospitality'],
    slug: 'travel-backlinks'
  },
];

const FeaturedSellers = () => {
  const [sellers] = useState(mockFeaturedSellers);

  return (
    <section className="bg-gray-50 py-8 md:py-16">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-6 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold mb-2 md:mb-3">Featured Sellers</h2>
          <p className="text-base md:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
            Discover our top-rated link providers with proven track records
          </p>
        </div>

        <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {sellers.map((seller) => (
            <SellerCard key={seller.id} {...seller} />
          ))}
        </div>

        <div className="mt-8 md:mt-10 text-center">
          <Link to="/sellers">
            <Button size="lg" variant="outline" className="px-6 sm:px-8 w-full sm:w-auto">
              View All Sellers
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedSellers;
